module.exports = __webpack_public_path__ + "img/other-active.41fa9ad5.svg";